import { PanelModes, PanelNames } from "panels/constants"
import { PanelsState } from "./types"

export const initialState: PanelsState = {
    mode: {
        [PanelNames.Bottom]: PanelModes.MaximizedLocked,
        [PanelNames.Controls]: PanelModes.Regular,
        [PanelNames.Left]: PanelModes.MaximizedLocked,
        [PanelNames.LeftBottom]: PanelModes.Hidden,
        [PanelNames.LeftTop]: PanelModes.Hidden,
        [PanelNames.Notifications]: PanelModes.Minimized,
        [PanelNames.Overlay]: PanelModes.Hidden,
        [PanelNames.Perimeter]: PanelModes.Hidden,
        [PanelNames.Snapshot]: PanelModes.Hidden,
        [PanelNames.RightBottom]: PanelModes.Hidden,
        [PanelNames.RightTop]: PanelModes.Hidden,
        [PanelNames.Top]: PanelModes.Regular,
        [PanelNames.Wallpaper]: PanelModes.Regular,
        [PanelNames.Wallboard]: PanelModes.Regular,
    },
}

export const withActionPrefix = (actionTypeName: string) => `panels/${actionTypeName}`
